import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { LauraSection } from './components/LauraSection';
import { CuisineSection } from './components/CuisineSection';
import { SpecialtiesSection } from './components/SpecialtiesSection';
import { SpacesSection } from './components/SpacesSection';
import { WineSection } from './components/WineSection';
import { GallerySection } from './components/GallerySection';
import { MenuSection } from './components/MenuSection';
import { ReviewsSection } from './components/ReviewsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-laura-cream text-laura-dark font-lato selection:bg-laura-olive selection:text-laura-cream" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <LauraSection data-id="element-5" />
        <CuisineSection data-id="element-6" />
        <SpecialtiesSection data-id="element-7" />
        <SpacesSection data-id="element-8" />
        <WineSection data-id="element-9" />
        <GallerySection data-id="element-10" />
        <MenuSection data-id="element-11" />
        <ReviewsSection data-id="element-12" />
        <ContactSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}